export const format_name: (name: string)=>string  = (name: string) =>  {
    return "The " + name.replace(/_/g, " ").toLocaleUpperCase()
}
